import {FormHelperText, TextField, Button} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useContext} from 'react';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {postPreviewFile} from '../redux/reducers/PreviewFile';
import PageLoader from '../components/PageLoader';
import {ThemeContext} from '../themes/ThemeProvider';

const PreviewFileEmail = ({dockey, moduleName}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {isLoading} = useSelector(
    ({addPrviewFile}) => addPrviewFile,
  );
  const dispatch = useDispatch();
  const initialValues = {
    previewEmail: [],
  };

  const validationSchema = Yup.object().shape({
    previewEmail: Yup.mixed()
      .test('previewEmail', 'Invalid Email Address(es)', (value) => {
        if (value?.length) {
          const modifiedValue = value?.split(',');
          const reqArr =
            modifiedValue && modifiedValue?.length > 0 ?
              modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
              [];
          if (reqArr?.length === modifiedValue?.length) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      })
      .test('previewEmail', 'Email Address(es) is required', (val) => {
        if (val?.length > 0) {
          return true;
        } else {
          return false;
        }
      }),
  });

  const handleSubmit = (values) => {
    const payload = {
      dockey: dockey,
      email: values?.previewEmail ? values?.previewEmail.split(',') : [],
      moduleName: moduleName ? moduleName : '',
    };
    dispatch(postPreviewFile(payload));
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
        enableReinitialize
      >
        {(props) => {
          const {
            handleChange,
            touched,
            errors,
            setFieldValue,
            handleSubmit,
            handleBlur,
            values,
            resetForm,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="col">
                <div className="row align-items-center">
                  <div className="col-md-12 form-group new-standard-textfields form-group ">
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Your Email Address(es)`}
                      label={'Email Address'}
                      multiline={true}
                      minRows={1}
                      maxRows={1}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name="previewEmail"
                      required
                      //   disabled={Boolean(eventTacticData?.code)}
                      value={values?.previewEmail}
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('previewEmail', e.target.value);
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.previewEmail}
                      error={Boolean(touched.previewEmail && errors.previewEmail)}
                    />
                    <FormHelperText>
                      {touched.previewEmail && errors?.previewEmail && errors.previewEmail}
                    </FormHelperText>
                  </div>
                  <div className="col-md-12 d-flex justify-content-center mb-2 new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        resetForm(initialValues);
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      Send
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default PreviewFileEmail;
